import { render, staticRenderFns } from "./StoreOpenScheduleAddEdit.vue?vue&type=template&id=285e1dd2"
import script from "./StoreOpenScheduleAddEdit.vue?vue&type=script&lang=js"
export * from "./StoreOpenScheduleAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports